import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Menos hinchazón abdominal desde los primeros días', 'Energía más estable durante el día', 'Menos antojos por la tarde', 'Mejor descanso nocturno', 'Sensación de liviandad en el cuerpo'];
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8 relative overflow-hidden" data-id="element-20">
      {/* Decorative Gold Blur */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-21" />

      <div className="max-w-[1400px] mx-auto relative z-10" data-id="element-22">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-23">
          {/* Left Column */}
          <div className="space-y-10" data-id="element-24">
            

            

            {/* Mini testimonial card */}
            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.35
          }} className="bg-card/60 border border-border/50 rounded-xl px-5 py-5" data-id="element-25">
              <p className="text-sm text-foreground/70 font-body uppercase tracking-wider font-bold mb-2" data-id="element-26">
                Una alumna dijo:
              </p>
              <p className="text-base text-foreground/90 font-body font-medium italic leading-relaxed" data-id="element-27">
                "A la semana ya me sentía menos inflamada y con más energía. Lo
                pude sostener porque es simple."
              </p>
              <p className="text-sm text-foreground/60 font-body mt-2" data-id="element-28">
                — Flor, 39 (Argentina)
              </p>
            </motion.div>

            {/* Emotional closer */}
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.45
          }} className="text-xl md:text-2xl font-display font-bold italic leading-relaxed text-gradient-gold" data-id="element-29">
              "Por primera vez en años, te mirarás al espejo y dirás:{' '}
              <span className="not-italic" data-id="element-30">AHÍ ESTÁS… te extrañé tanto.</span>"
            </motion.p>
          </div>

          {/* Right Column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex justify-center lg:justify-end" data-id="element-31">
            <div className="relative w-full max-w-sm" data-id="element-32">
              <div className="rounded-2xl shadow-gold overflow-hidden border border-gold/20" data-id="element-33">
                <img src="https://cdn.magicpatterns.com/uploads/hmh2MZ8WSYLTLedanFfJSo/cosmos-image-1775842875547.png" alt="Protocolo H.E.R. — Mujer planificando su alimentación" className="w-full h-auto object-cover" data-id="element-34" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}